/* eslint-disable no-param-reassign */
import orderService from "src/services/orderService";

export const SEARCH_ORDERS_REQUEST = "@order/search-orders-request";
export const SEARCH_ORDERS_SUCCESS = "@order/search-orders-success";
export const SEARCH_ORDERS_FAILURE = "@order/search-orders-failure";

export const GET_ORDERS_REQUEST = "@order/get-orders-request";
export const GET_ORDERS_SUCCESS = "@order/get-orders-success";
export const GET_ORDERS_FAILURE = "@order/get-orders-failure";

export const GET_ORDER_REQUEST = "@order/get-order-request";
export const GET_ORDER_SUCCESS = "@order/get-order-success";
export const GET_ORDER_FAILURE = "@order/get-order-failure";

export const ADD_ORDER_REQUEST = "@order/add-order-request";
export const ADD_ORDER_SUCCESS = "@order/add-order-success";
export const ADD_ORDER_FAILURE = "@order/add-order-failure";

export const UPDATE_ORDER_REQUEST = "@order/udpate-order-request";
export const UPDATE_ORDER_SUCCESS = "@order/udpate-order-success";
export const UPDATE_ORDER_FAILURE = "@order/udpate-order-failure";

export const DELETE_ORDER_REQUEST = "@order/delete-order-request";
export const DELETE_ORDER_SUCCESS = "@order/delete-order-success";
export const DELETE_ORDER_FAILURE = "@order/delete-order-failure";

export const GET_ORDER_ITEMS_REQUEST = "@order/get-order-items-request";
export const GET_ORDER_ITEMS_SUCCESS = "@order/get-order-items-success";
export const GET_ORDER_ITEMS_FAILURE = "@order/get-order-items-failure";

export const EDIT_TAX_ORDER = "@order/edit-tax-order";
export const EDIT_TAX_ORDER_FAILURE = "@order/edit-tax-order-failure";

export function searchOrders(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_ORDERS_REQUEST});
      const response = await orderService.searchOrders(data);
      dispatch({
        type: SEARCH_ORDERS_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.headers["x-total-items"],
          totalItems: response?.data?.total_sales
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_ORDERS_FAILURE});
      throw error;
    }
  };
}

export function editTaxOrderDetail(id, data) {
  return (dispatch) => {
    try {
      dispatch({
        type: EDIT_TAX_ORDER,
        payload: {
          id,
          data
        }
      });
    } catch (error) {
      dispatch({type: EDIT_TAX_ORDER_FAILURE});
      throw error;
    }
  };
}

export function getListOrders(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDERS_REQUEST});
      const response = await orderService.getListOrders(data);
      dispatch({
        type: GET_ORDERS_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDERS_FAILURE});
      throw error;
    }
  };
}

export function getOrder(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_REQUEST});
      const response = await orderService.getOrder(id);
      dispatch({
        type: GET_ORDER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_FAILURE});
      throw error;
    }
  };
}

export function addOrder(data) {
  return async (dispatch) => {
    try {
      dispatch({type: ADD_ORDER_REQUEST});
      const response = await orderService.createStation(data);
      dispatch({
        type: ADD_ORDER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: ADD_ORDER_FAILURE});
      throw error;
    }
  };
}

export function updateOrder(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_ORDER_REQUEST});
      const response = await orderService.updateOrder(data);
      dispatch({
        type: UPDATE_ORDER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_ORDER_FAILURE});
      throw error;
    }
  };
}

export function deleteOrder(order) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_ORDER_REQUEST});
      if (typeof order === "object") {
        await orderService.deleteOrder(order.id);
      } else {
        await orderService.deleteOrder(order);
      }
      dispatch({
        type: DELETE_ORDER_SUCCESS,
        payload: {
          order
        }
      });
    } catch (error) {
      dispatch({type: DELETE_ORDER_FAILURE});
      throw error;
    }
  };
}

export function getOrderItems(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ORDER_ITEMS_REQUEST});
      const response = await orderService.getOrderItems(data);

      //   const retData = [];
      //   await Promise.all(
      //     response.map(async (item) => {
      //       const {sku} = item;

      //       const res = await skuService.getSkuById(sku);

      //       if (res && res.images && res.images.length > 0) {
      //         item.image = res.images[0];
      //       } else {
      //         item.image = "";
      //       }

      //       // item.prod_name = (res.item.names.en) ? (res.item.names.en) : ("");
      //       let prodName = "";
      //       if (res?.item.names.vi) {
      //         prodName = res.item.names.vi;
      //       } else if (res?.item.names.en) {
      //         prodName = res.item.names.en;
      //       }
      //       item.prod_name = prodName;
      //       item.item_sku = res?.sku ? res.sku : "";
      //       retData.push(item);
      //     })
      //   );
      dispatch({
        type: GET_ORDER_ITEMS_SUCCESS,
        payload: {
          response: response?.order_items ?? []
        }
      });
    } catch (error) {
      dispatch({type: GET_ORDER_ITEMS_FAILURE});
      throw error;
    }
  };
}
